import {
  AuthPage,
  CatalogPage,
  ChatPage,
  FittingPage,
  OnboardingPage,
  OutfitsPage,
  PaymentResultPage,
  ProfilePage,
  StylistPage,
  StylistsPage,
  SubscriptionPage,
  TermsPage,
} from './pages';
import { RoutePaths } from '@/shared/routePaths';
import type { RouteLeafConfig } from '@/types/utils';

export const appPublicRoutes: readonly RouteLeafConfig[] = [
  { path: RoutePaths.AUTH, Component: AuthPage },
  { path: RoutePaths.ONBOARDING, Component: OnboardingPage },
  { path: RoutePaths.TERMS, Component: TermsPage },
  { path: RoutePaths.PAYMENT_RESULT, Component: PaymentResultPage },
];

export const protectedLazyLeaves: readonly RouteLeafConfig[] = [
  { path: RoutePaths.OUTFITS, Component: OutfitsPage },
  { path: RoutePaths.FITTING, Component: FittingPage },
  { path: RoutePaths.CHAT, Component: ChatPage },
  { path: RoutePaths.PROFILE, Component: ProfilePage },
  { path: RoutePaths.PROFILE_SUBSCRIPTION, Component: SubscriptionPage },
];

export const feedChildRouteConfig: readonly RouteLeafConfig[] = [
  { path: RoutePaths.CATALOG, Component: CatalogPage },
  { path: RoutePaths.STYLISTS, Component: StylistsPage },
  { path: RoutePaths.STYLIST, Component: StylistPage },
];
